import { BooleanInput, Edit, SimpleForm, TextInput } from "react-admin";


export function EmailDomainEdit() {
    return (
        <Edit>
            <SimpleForm>
                <TextInput source="id" label={"Domain"} />
                <BooleanInput source="isDisposable" />
            </SimpleForm>
        </Edit>
    )
}